global?.modules?.set({
  name: 'forms',
  is_booted: false,
  async init() {
    if (this.is_booted) {
      return;
    }
    this.is_booted = true;

    initForms();
  },
});

function initForms() {
  const contactForm = document.getElementById('s-contacts__form');

  if (contactForm) {
    processForm({
      form: contactForm,
      beforeSend: () => {
        const btn = contactForm.querySelector('button[type="submit"]');
        if (!btn) return;

        btn.disabled = true;
        btn.classList.add('loading');
        btn.insertAdjacentHTML('afterbegin', getLoaderMarkup());
      },

      validation: (values) => {
        let isNotifyShown = false;

        const errors = validate(values, {
          subject: { required: 'Required' },
          contact_email: { required: 'Required', email: 'Email is not valid', },
          contact_name: { required: 'Required' },
          description: { required: 'Required' },
        });

        const hasErrors = Object.keys(errors).length;
        if (hasErrors) {
          if (!isNotifyShown) {
            isNotifyShown = true;
            contactForm.addEventListener('input', () => (isNotifyShown = false), { once: true });
          }
          return false;
        }

        if (!values['g-recaptcha-response']) {
          showNotify({ status: 'error', message: 'Completa la verifica captcha' });
          return false;
        }

        return true;
      },

      onSuccessSend: () => {
        const btn = contactForm.querySelector('button[type="submit"]');

        btn.disabled = false;
        btn.querySelector('.loader-spinner').remove();
        btn.classList.remove('loading');

        contactForm.reset();

        if (window.grecaptcha) {
          window.grecaptcha.reset();
        }
      }
    });
  }
}

function processForm({ form, beforeSend, validation, onSuccessSend, ...data }) {
  form.addEventListener('submit', async (ev) => {
    ev.preventDefault();
    const formData = new FormData(form);
    const values = Object.fromEntries(formData);

    if (!validation(values)) return;
    beforeSend();

    await handleSubmit({ ...values, ...data }, { onSuccess: onSuccessSend, form });
  });
}

global.processForm = processForm;

const handleSubmit = async (values, { onSuccess, form }) => {
  const action = form.getAttribute('action') || '#';
  const method = form.getAttribute('method') || 'POST';

  const btn = form.querySelector('button[type="submit"]');

  btn.disabled = true;

  try {
    const response = await sendRequest(method, action, values);
    if (response.message) showNotify({ status: response.success ? 'success' : 'error', message: response.message || '' });
  } catch (error) {
    showNotify({ status: 'error', message: 'Error' });
  } finally {
    onSuccess();
  }
};

global.handleSubmit = handleSubmit;

function getLoaderMarkup() {
  return `
    <span class="loader-spinner">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
           viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 12a9 9 0 1 1-6.219-8.56"></path>
      </svg>
    </span>`;
}